import type { CSSProperties, HTMLAttributes } from 'react'
import styled, { keyframes } from 'styled-components'
import { sc } from 'utils'

type Props = {
  size?: number | string
  centered?: boolean
} & HTMLAttributes<HTMLElement>

export default function Spinner({ size = 24, className, style, ...props }: Props) {
  const spinnerStyles = {
    ...style,
    '--size': typeof size === 'string' ? size : `${size}px`
  } as CSSProperties

  return (
    <Wrapper role="img" style={spinnerStyles} {...props}>
      <div />
      <div />
      <div />
      <div />
    </Wrapper>
  )
}

const spinner = keyframes`
  to { transform: rotate(360deg); }
`

const Wrapper = styled.div<{ centered?: boolean }>`
  flex: none;
  width: var(--size);
  height: var(--size);
  position: relative;
  color: inherit;

  ${sc('centered', 'margin: auto;')}

  div {
    width: 100%;
    height: 100%;
    position: absolute;
    color: inherit;
    border: calc(var(--size) / 12) solid transparent;
    border-top-color: currentColor;
    border-radius: 50%;
    animation: ${spinner} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    box-sizing: border-box;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`
